import * as gqlb from "gql-query-builder";
export const SAVE_ACTIVITY = gqlb.mutation({
  operation: "saveActivity",
  fields: ["id", "name"],
  variables: {
    input: {
      type: "ActivityInput",
      required: true,
    },
  },
});

export const LIST_ACTIVITIES = gqlb.query({
  operation: "listActivities",
  fields: [
    {
      operation: "paginatorInfo",
      fields: [
        "count",
        "currentPage",
        "firstItem",
        "hasMorePages",
        "lastItem",
        "lastPage",
        "perPage",
        "total",
      ],
      variables: {},
    },
    {
      operation: "data",
      fields: ["id", "name", "code", "active"],
      variables: {},
    },
  ],
  variables: {
    page: {
      type: "Int",
    },
    first: {
      type: "Int",
    },
    input: {
      type: "ListActivitiesFilterInput",
    },
  },
});

export const ACTIVITY = gqlb.query({
  operation: "activity",
  fields: ["code", "name", "active"],
  variables: {
    id: {
      type: "Int",
      required: true,
    },
  },
});
export const DELETE_ACTIVITY = gqlb.mutation({
  operation: "deleteActivity",
  fields: [],
  variables: {
    id: {
      type: "Int",
      required: true,
    },
  },
});
